import { render, staticRenderFns } from "./DragDropfile.vue?vue&type=template&id=df8d70f2&scoped=true"
import script from "./DragDropfile.vue?vue&type=script&lang=js"
export * from "./DragDropfile.vue?vue&type=script&lang=js"
import style0 from "./DragDropfile.vue?vue&type=style&index=0&id=df8d70f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8d70f2",
  null
  
)

export default component.exports